var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-hidden lg:tw-flex tw-items-center tw-justify-center tw-w-[480px] tw-pt-8 tw-h-full tw-cursor-pointer tw-overflow-y-hidden",attrs:{"id":"fundo"},on:{"click":_vm.abrirLink}},[_c('img',{attrs:{"src":"https://econodata.com.br/banner-login/","alt":"","width":"480"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }